import {CheckIcon, CommentIcon, DotFillIcon, FileDiffIcon, ShieldIcon} from '@primer/octicons-react'
import type {Icon} from '@primer/octicons-react'
import {
  DeferredType,
  type PendingReviewRequest,
  ReviewState,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

export function reviewState(state: ReviewState): {icon: Icon; className: string; label: string} {
  switch (state) {
    case ReviewState.APPROVED:
      return {icon: CheckIcon, className: 'color-fg-success', label: 'Approved'}
    case ReviewState.CHANGES_REQUESTED:
      return {icon: FileDiffIcon, className: 'color-fg-danger', label: 'Changes requested'}
    case ReviewState.COMMENTED:
      return {icon: CommentIcon, className: 'color-fg-muted', label: 'Commented'}
    case ReviewState.DISMISSED:
      return {icon: ShieldIcon, className: 'color-fg-muted', label: 'Dismissed'}
    default:
      return {icon: DotFillIcon, className: 'color-fg-attention', label: 'Pending'}
  }
}

export function reviewStateTooltip(state: ReviewState, name: string): string {
  switch (state) {
    case ReviewState.APPROVED:
      return `${name} approved these changes`
    case ReviewState.CHANGES_REQUESTED:
      return `${name} requested changes`
    case ReviewState.COMMENTED:
      return `${name} left review comments`
    case ReviewState.DISMISSED:
      return `${name}'s review was dismissed`
    default:
      return `Awaiting requested review from ${name}`
  }
}

export function deferredTooltip(deferredType: DeferredType, name: string): string {
  if (deferredType === DeferredType.COPILOT) {
    return `${name} will automatically review once the pull request is marked ready for review`
  }
  return `${name} will be requested when the pull request is marked ready for review`
}

export function codeOwnerTooltip(request: PendingReviewRequest): string {
  const name = request.reviewer?.displayLogin ?? ''
  if (request.isCodeOwnerFromDelegation && request.delegatedFromTeam) {
    return `${name} is a code owner automatically assigned from ${request.delegatedFromTeam.displayLogin}`
  }
  return `${name} is a code owner`
}
